import * as THREE from 'three';
import { loadKtx2 } from '../../../../render/textures/ktx2Loader';

// PBR submarine hull material. Loads the four maps the user dropped into
// public/materials/submarine and hands them to a stock MeshStandardMaterial.
// Heightmap is intentionally unused — displacement needs subdivided geometry,
// and the submarine GLB ships with the topology we want for collision.
//
// UVs are box-projected in world space onto the GLB at template-bake time
// (see WoodenBoatAssets.applyBoxProjectionUVs), so the same instance of this
// material can be shared across every mesh in the model and tile consistently
// across the hull regardless of the GLB's original UV layout.
const BASE_PATH = '/materials/submarine';

function loadColor(url: string): THREE.Texture {
  const tex = loadKtx2(url);
  tex.colorSpace = THREE.SRGBColorSpace;
  tex.wrapS = tex.wrapT = THREE.RepeatWrapping;
  tex.anisotropy = 8;
  return tex;
}

function loadData(url: string): THREE.Texture {
  const tex = loadKtx2(url);
  tex.colorSpace = THREE.NoColorSpace;
  tex.wrapS = tex.wrapT = THREE.RepeatWrapping;
  tex.anisotropy = 8;
  return tex;
}

export default class SubmarineHullMaterial extends THREE.MeshStandardMaterial {
  constructor(_params: Record<string, unknown> = {}) {
    const baseColor = loadColor(`${BASE_PATH}/material_basecolor.ktx2`);
    const normal = loadData(`${BASE_PATH}/material_normal.ktx2`);
    const roughness = loadData(`${BASE_PATH}/material_roughness.ktx2`);
    const metalness = loadData(`${BASE_PATH}/material_metalness.ktx2`);

    super({
      map: baseColor,
      normalMap: normal,
      roughnessMap: roughness,
      metalnessMap: metalness,
      // Painted-steel submarine hull. Roughness/metalness textures drive the
      // shading; the scalars stay at full strength so the maps pass through.
      // envMapIntensity damped so the IBL can't push the hull into mirror
      // territory under our default studio lighting.
      roughness: 1.0,
      metalness: 1.0,
      envMapIntensity: 0.5
    });
  }

  setTime(_t: number): void {}
}
